import React, { useState } from "react";
import { motion } from "framer-motion";
import { FAQ_ITEMS } from "../content";
import { Breadcrumbs } from "../components/Layout";
import { Reveal } from "../components/Motion";

function FaqItem({ item, index }) {
  const [open, setOpen] = useState(index === 0);
  return (
    <div className="faq-item">
      <h2>
        <button
          type="button"
          className="faq-item__btn"
          aria-expanded={open}
          aria-controls={`faq-panel-${index}`}
          data-testid={`faq-item-${index}`}
          onClick={() => setOpen((v) => !v)}
        >
          {item.q}
          <span className="faq-item__sign" aria-hidden="true">
            +
          </span>
        </button>
      </h2>
      <motion.div
        id={`faq-panel-${index}`}
        className="faq-item__panel"
        initial={false}
        animate={{ height: open ? "auto" : 0 }}
        transition={{ duration: 0.45, ease: [0.16, 1, 0.3, 1] }}
      >
        <p className="faq-item__answer">{item.a}</p>
      </motion.div>
    </div>
  );
}

export default function FaqPage() {
  return (
    <>
      <section className="page-head" data-testid="faq-head">
        <Breadcrumbs current="FAQ" />
        <h1 className="page-head__title">Pertanyaan umum</h1>
        <p className="page-head__lede">
          Hal-hal yang paling sering ditanyakan tentang kedai kami — dari status halal sampai cara
          menemukan gang kami.
        </p>
      </section>
      <section className="section">
        <Reveal>
          <div className="faq-list">
            {FAQ_ITEMS.map((item, i) => (
              <FaqItem key={item.q} item={item} index={i} />
            ))}
          </div>
        </Reveal>
      </section>
    </>
  );
}
